import React, { useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardMedia,
  CardContent,
  TextField,
  CircularProgress,
} from "@mui/material";
import { Link } from "react-router-dom";
import Header from "../Header";
import Footer from "../Footer";
import locationSmall from "../../assets/images/location-small.svg";
import Search from "../../assets/images/search.svg";
import useRequests from "../../utils/useRequests";
import Snackbars from "../../utils/Snackbars";


const ResellMKT = () => {
  const { getRequest } = useRequests();

  const [tickets, setTickets] = useState([]);
  const [bannerUrl, setbannerUrl] = useState(null);
  const [searchQuery, setSearchQuery] = React.useState("");
  const filteredEvents = tickets.filter((ticket) => {
    const city = `${ticket.city}`.toLowerCase().trim();

    const searchLower = searchQuery.toLowerCase().trim();

    return city.includes(searchLower);
  });

  const [loading, setLoading] = useState(true);

  const [AlertData, setAlertData] = React.useState({
    variant: "",
    message: "",
  });
  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: "",
        message: "",
      }));
    }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
  };

  const fetchResaleMarket = async () => {
    const response = await getRequest("resell-tickets");

    if (response && response.code === 200) {
      if(response.data.length!=0){
      const ticketsData = Array.isArray(response.data.data)
        ? response.data.data
        : [response.data.data];
        console.log(ticketsData)
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const ValidTickets = ticketsData.filter((ticket) => {
        if(ticket.event_ticket_date){
            return ticket.resale_status != "Sold" && ticket.status == "Enable" && new Date(ticket.event_ticket_date) >= today;
        }
        return ticket.resale_status != "Sold" && ticket.status == "Enable" && new Date(ticket.end_datetime) >= today;
      });

     // Group tickets by event ID
     const groupedByEvent = ValidTickets.reduce((acc, ticket) => {
      if (!acc[ticket.e_id]) {
        acc[ticket.e_id] = [];
      }
      acc[ticket.e_id].push(ticket);
      return acc;
    }, {});

    // Create unique events with price range
    const uniqueEvents = Object.values(groupedByEvent).map((eventTickets) => {
      const baseTicket = eventTickets[0];
      const resalePrices = eventTickets.map((t) => Number(t.resale_price));
      const lowest_price = Math.min(...resalePrices);
      const highest_price = Math.max(...resalePrices);

      return {
        ...baseTicket,
        lowest_price,
        highest_price,
      };
    });
      setTickets(uniqueEvents);
      setbannerUrl(response.data.banner);
    }
    } else {
      console.error("Failed to fetch events:", response?.message);
      setAlertData((prev) => ({
        ...prev,
        variant: "error",
        message: "Failed to fetch events",
      }));
    }
    resetAlertData();
    setLoading(false);
  };

  React.useEffect(() => {
    fetchResaleMarket();
  }, []);

  return (
    <Box sx={{ flexGrow: 1 }}>
      {AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="center-App" container direction="column">
        <Header name="Resell Market" />
        <Box
          sx={{
            padding: "15px",
            float: "left",
            width: "100%",
            height: "calc(100vh - 160px)",
            overflow: "auto",
          }}
        >

          <form className="loginForm">
                <div className="position-relative fullName">
                  <img
                    src={Search}
                    alt="Full Name"
                    width={19}
                    className="textboxLefticon search"
                  />
                  <TextField
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    placeholder="Search City"
                    autoComplete="off"
                    type="text"
                    name="fullName"
                    className={`search-city`}
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    style={{ marginTop: 0 }}
                  />
                </div>
              </form>

          {loading ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                minHeight: "300px",
              }}
            >
              <CircularProgress color="primary" />
              <p>Loading ...</p>
            </Box>
          ) : (
            <Box>
              <div container spacing={2}>
                {filteredEvents.length > 0 ? (
                  filteredEvents.map((ticket) => {
                    return (
                      <div item xs={12} key={ticket.e_id}>
                        <Box className="events-box">
                          <Link
                            to={`/resell-market/ticket-list/${ticket.e_id}`}
                            style={{ textDecoration: "none" }}
                          >
                            {" "}
                            {/* Wrap card in a Link */}
                            <Card
                              sx={{
                                borderRadius: "10px",
                                padding: "15px",
                                boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                              }}
                            >
                              <div
                                className="position-relative radius-img-box"
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <CardMedia
                                  component="img"
                                  height="185"
                                  image={bannerUrl + ticket.banner}
                                  alt={ticket.name}
                                  className="small-event-img"
                                />
                                <Typography
                                  variant="h6"
                                  component="div"
                                  sx={{
                                    float: "left",
                                    width: "calc(100% - 80px)",
                                    color: "#6638A2",
                                    marginTop: "5px",
                                    fontSize: "21px",
                                    marginBottom: "10px",
                                    lineHeight: "27px",
                                    fontWeight: "500",
                                    paddingLeft: "15px",
                                  }}
                                >
                                  {ticket.name}
                                </Typography>
                              </div>
                             
                              <CardContent style={{ padding: "9px 5px" }}>
                                <CardContent style={{ padding: "0px 5px 0" }}>
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      marginTop: "7px",
                                      fontSize: "16px",
                                      color: "#341439",
                                    }}
                                  >
                                    <img
                                      src={locationSmall}
                                      alt=""
                                      className="small-svg"
                                    />
                                    <span
                                      style={{
                                        float: "left",
                                        marginTop: "4px",
                                      }}
                                    >
                                      {ticket.address}
                                    </span>
                                  </Typography>
                                </CardContent>
                              </CardContent>
                              {/* <Typography
                                  variant="h6"
                                  component="div"
                                  sx={{
                                    float: "left",
                                    width: "calc(100% - 80px)",
                                    color: "#6638A2",
                                    marginTop: "5px",
                                    fontSize: "17px",
                                    marginBottom: "1px",
                                    lineHeight: "27px",
                                    fontWeight: "500",
                                    paddingLeft: "15px",
                                  }}
                                >
                                  Lowest Ticket Price : {ticket.lowest_price}
                                </Typography>
                                <Typography
                                  variant="h6"
                                  component="div"
                                  sx={{
                                    float: "left",
                                    width: "calc(100% - 80px)",
                                    color: "#6638A2",
                                    marginTop: "1px",
                                    fontSize: "17px",
                                    marginBottom: "10px",
                                    lineHeight: "27px",
                                    fontWeight: "500",
                                    paddingLeft: "15px",
                                  }}
                                >
                                Highest Ticket Price : {ticket.highest_price} 
                                </Typography> */}
                                                              <Typography
                                                                variant="body2"
                                                                sx={{
                                                                  display: "flex",
                                                                  alignItems: "left",
                                                                  marginTop: "3px",
                                                                }}
                                                              >
                                                                <span
                                                                  style={{
                                                                    float: "left",
                                                                    marginTop: "10px",
                                                                    color: "#028E54",
                                                                    fontSize: "15px",
                                                                    textTransform: "uppercase",
                                                                    fontWeight: "500",
                                                                    paddingLeft: "30px",
                                                                  }}
                                                                >
                                                                  Lowest Ticket Price ₹ {ticket.lowest_price}
                                                                </span>
                                                              </Typography>

                                                              <Typography
                                                                variant="body2"
                                                                sx={{
                                                                  display: "flex",
                                                                  alignItems: "left",
                                                                  marginTop: "1px",
                                                                }}
                                                              >
                                                                <span
                                                                  style={{
                                                                    float: "left",
                                                                    marginTop: "1px",
                                                                    color: "#028E54",
                                                                    fontSize: "15px",
                                                                    textTransform: "uppercase",
                                                                    fontWeight: "500",
                                                                    paddingLeft: "30px",
                                                                  }}
                                                                >
                                                                  Highest Ticket Price ₹ {ticket.highest_price}
                                                                </span>
                                                              </Typography>
                            </Card>
                          </Link>
                        </Box>
                      </div>
                    );
                  })
                ) : (
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{ textAlign: "center", marginTop: "20px" }}
                  >
                    No events found.
                  </Typography>
                )}
              </div>
            </Box>
          )}
        </Box>
        <Footer />
      </div>
    </Box>
  );
};

export default ResellMKT;
